import { render, staticRenderFns } from "./virtual_list.vue?vue&type=template&id=4368a4e3"
import script from "./virtual_list.vue?vue&type=script&lang=js"
export * from "./virtual_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports